<template>
	<ActivityLayout class="goal-kr-sort-order-activity">
		<template #badge>
			<OrderChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				name: activity.name,
				changedBy: activity.changedBy,
				from: activity.from,
				to: activity.to
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import OrderChangeActivityBadge from "../Activity/OrderChangeActivityBadge.vue";

export default {
	name: "GoalKRSortOrderActivity",
	components: {
		ActivityLayout,
		OrderChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, name:String, to:Number, from:Number } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalKRSortOrderActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
